module.exports = __webpack_public_path__ + "img/cooperate_29.106acc55.png";